const { default: axiosIns } = require('@/libs/axios')

const PropertiesService = {
  // GET - PropertyApiController
  async getProperties() {
    return axiosIns.get('admin/properties')
      .then(response => response.data)
  },
  async getAllProperties() {
    return axiosIns.get('admin/properties/all')
      .then(response => response.data)
  },
  // POST - PropertyApiController
  async getFilteredProperties(filter) {
    return axiosIns.post('admin/properties/filters', filter)
      .then(response => response.data)
  },
  // PUT - PropertyApiContoller
  async updateProperties(property) {
    return axiosIns.put(`admin/properties/${property.id}`, property)
      .then(response => response.data)
  },
}

export default PropertiesService
